/* globals Forms, Option */
import Appropriate from 'lib/appropriate'

window['search#search'] = function () {
  $('a.storelink').on('click', function () {
    $(this).addClass('load')
  })

  $('#list_id').on('change', function () {
    const listId = this.value

    if (listId) {
      $.getJSON(`/newsletter2go/populate_groups?list_id=${listId}`, function (data) {
        populateGroups('#group_id', data)
      })
    }
  })

  function populateGroups (selector, data) {
    const select = $(selector)
    select.select2('destroy')
    select.empty()
    select.append(new Option())

    data.forEach(elem => {
      select.append(new Option(elem[0], elem[1]))
    })

    Forms.initSelect2(select)
  };

  // Appropriate to TP, NL2GO, Projects and Positions
  new Appropriate({
    formSelector: $('#assign_talent_pool_form, #assign_position_form, #assign_project_work_form, #assign_cleverreach_form, #cleverreach_new_group_form, #drop_out_form'),
    onCandidateCheck: (checkedCount, allChecked) => {
      $('.assign-search-results').text(checkedCount
        ? I18n.t('customizable_table.assign_selected_candidates')
        : I18n.t('customizable_table.assign_candidates'))
    }
  })

  // Talent Pool cancellation actions Confirm email/Reject email/Restore/Remove
  new Appropriate({
    formSelector: $('#talent_pool_confirm_form, #talent_pool_reject_form, #talent_pool_declined_forms'),
    onCandidateCheck: (checkedCount, allChecked) => {
      $('.multiple-action').attr('disabled', !checkedCount)
    }
  })

  // Leads steps
  Helpers.initCollapsableTable()
}
